/**
 * Copyright © 2026 Farmlands Co-operative Society Limited. All rights reserved.
 *
 * This document contains confidential information and is the property of Farmlands.
 * Unauthorised reproduction or distribution of any part of this publication is prohibited without written consent.
 */

import { useLocation } from "react-router-dom";

import { TestIds } from "../../../testIds";
import { useBottomNavItems } from "../hooks/useBottomNavItems";
import { useNavigateToItem } from "../hooks/useNavigateToItem";
import { NavItemModel } from "../NavItem";
import { isRouteActive } from "../utils/is-route-active";

import { BottomNav } from "./BottomNav";

const MobileBottomNav = () => {
  const { pathname } = useLocation();
  const navigateTo = useNavigateToItem();
  const bottomItems = useBottomNavItems();

  const items: NavItemModel[] = bottomItems.map((item) => ({
    id: item.destinationId,
    label: item.label,
    icon: <item.icon aria-hidden className="size-4" strokeWidth={1.5} />,
    isActive: isRouteActive(pathname, item.to),
    testId: item.testId,
    onSelect: () => navigateTo(item),
  }));

  return <BottomNav items={items} testId={TestIds.components.layout.nav.bottomNavigation} />;
};

export default MobileBottomNav;
